import React from 'react';
import '../../../css/Admin.css';
import TituloPagina from '../../../js/Components/PageTitle';

const AdminHome: React.FC = () => {
      return (
        <div>
        <TituloPagina title="ADMIN - Portada | DentalPuente" />

<div className="pbot352">
      
This is admin
    </div>
    </div>
    );
}

export default AdminHome;
